import { useAddNotification } from '@va/dashboard/util-hooks';
import { useTranslate } from '@va/localization';
import { getAgencyUi } from '@va/standalone/shared/actions';
import { LegalLinkEnum, LegalLinksComponent } from '@va/ui/components/white-label-customisation';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateAgencyUi } from '../apiClient';
import useAgencyUi from '../useAgencyUi';

const LegalLinkContainer = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const { data: agencyUi } = useAgencyUi();
  const { id: agencyId, agencyLegalLinks } = agencyUi ?? {};

  const { showSuccessNotification, showErrorNotification } = useAddNotification();
  const { execute: updateLegalLinks, isLoading, isSucceeded, error, reset } = useUpdateAgencyUi();

  const getLink = useCallback(
    (type: LegalLinkEnum) => {
      return agencyLegalLinks?.find((item: { type: number; link: string }) => item.type === type)?.link ?? '';
    },
    [agencyLegalLinks],
  );

  const initialFormValues = useMemo(
    () => ({
      legalNoticeLink: getLink(LegalLinkEnum.legalNoticelink),
      privacyPolicyLink: getLink(LegalLinkEnum.privacyPolicyLink),
      termsOfUseLink: getLink(LegalLinkEnum.termsOfUseLink),
    }),
    [getLink],
  );

  useEffect(() => {
    if (isSucceeded) {
      reset();
      showSuccessNotification();
      dispatch(getAgencyUi());
    }
  }, [isSucceeded, showSuccessNotification, dispatch, reset]);

  useEffect(() => {
    if (error) {
      showErrorNotification();
    }
  }, [error, showErrorNotification]);

  return (
    <LegalLinksComponent
      onSubmit={(values) => {
        updateLegalLinks({
          agencyLegalLinks: [
            { type: LegalLinkEnum.legalNoticelink, link: values.legalNoticeLink },
            {
              type: LegalLinkEnum.privacyPolicyLink,
              link: values.privacyPolicyLink,
            },
            {
              type: LegalLinkEnum.termsOfUseLink,
              link: values.termsOfUseLink,
            },
          ],
        });
      }}
      isLoading={isLoading}
      initialFormValues={initialFormValues}
      saveButtonTooltip={!agencyId ? translate('whiteLabelCustomization.info.firstFillCustomUrl') : undefined}
    />
  );
};

export default LegalLinkContainer;
